<template lang="pug">
    div
        v-card( 
            class="mx-auto"
            color="transparent"
            max-width="600"
            style="box-shadow:none"
        )
            v-card-title
                h5 Product Ratings
            v-card-subtitle
                v-row
                    v-col.pa-0(cols="6")
                        v-rating(
                            background-color="grey"
                            color="#ffc107"
                            empty-icon="mdi-star-outline"
                            full-icon="mdi-star"
                            half-icon="mdi-star-half-full"
                            half-increments
                            length="5"
                            size="20"
                            :value="parseFloat(rating.star)"
                            readonly
                        )
                    v-col.pa-0.pl-3.align-self-center(cols="6")
                        h4(style="vertical-align:middle") {{rating.star}} Ratings ({{convertInt(rating.reviewcount)}})
</template>
<script>
export default {
    props:['rating'],
    methods:{
        convertInt(val){
            if(val>=1000000)
            {
                val=(val/1000000)+"M"
            }
            else if(val>=1000)
            {
                val=(val/1000)+"K";
            }
            return val;
        }
    }
}
</script>